module.exports = __webpack_public_path__ + "static/media/barchart.5c404470.png";